export const iconFontAwesomeHumanitarianShop = (
	<i className="fa-solid fa-shop"></i>
);
